/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Sales
 * Это Sales api сервер, для запросов от Frontend.  Для запросов требуется указать header с Authorization и типом Bearer.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface Sale
 */
export interface Sale {
  /**
   *
   * @type {string}
   * @memberof Sale
   */
  id: string
  /**
   *
   * @type {number}
   * @memberof Sale
   */
  saleId: number
  /**
   *
   * @type {string}
   * @memberof Sale
   */
  countItems: string
  /**
   *
   * @type {string}
   * @memberof Sale
   */
  priceItemsBuy: string
  /**
   *
   * @type {string}
   * @memberof Sale
   */
  priceItems: string
  /**
   *
   * @type {string}
   * @memberof Sale
   */
  priceItemsDiscount: string
  /**
   *
   * @type {string}
   * @memberof Sale
   */
  priceDiscount: string
  /**
   *
   * @type {string}
   * @memberof Sale
   */
  sumCommission: string
  /**
   *
   * @type {string}
   * @memberof Sale
   */
  sumRaise: string
  /**
   *
   * @type {string}
   * @memberof Sale
   */
  priceFinal: string
  /**
   *
   * @type {string}
   * @memberof Sale
   */
  sumGive: string
  /**
   *
   * @type {string}
   * @memberof Sale
   */
  sumBack: string
  /**
   *
   * @type {number}
   * @memberof Sale
   */
  dateOperation: number
  /**
   *
   * @type {string}
   * @memberof Sale
   */
  shopId: string
  /**
   *
   * @type {string}
   * @memberof Sale
   */
  shopSalePointId: string
  /**
   *
   * @type {string}
   * @memberof Sale
   */
  shopPaymentPointId: string
  /**
   *
   * @type {string}
   * @memberof Sale
   */
  userId: string
  /**
   *
   * @type {number}
   * @memberof Sale
   */
  createdAt: number
  /**
   *
   * @type {number}
   * @memberof Sale
   */
  updatedAt: number
}

/**
 * Check if a given object implements the Sale interface.
 */
export function instanceOfSale(value: object): value is Sale {
  if (!('id' in value) || value['id'] === undefined) return false
  if (!('saleId' in value) || value['saleId'] === undefined) return false
  if (!('countItems' in value) || value['countItems'] === undefined)
    return false
  if (!('priceItemsBuy' in value) || value['priceItemsBuy'] === undefined)
    return false
  if (!('priceItems' in value) || value['priceItems'] === undefined)
    return false
  if (
    !('priceItemsDiscount' in value) ||
    value['priceItemsDiscount'] === undefined
  )
    return false
  if (!('priceDiscount' in value) || value['priceDiscount'] === undefined)
    return false
  if (!('sumCommission' in value) || value['sumCommission'] === undefined)
    return false
  if (!('sumRaise' in value) || value['sumRaise'] === undefined) return false
  if (!('priceFinal' in value) || value['priceFinal'] === undefined)
    return false
  if (!('sumGive' in value) || value['sumGive'] === undefined) return false
  if (!('sumBack' in value) || value['sumBack'] === undefined) return false
  if (!('dateOperation' in value) || value['dateOperation'] === undefined)
    return false
  if (!('shopId' in value) || value['shopId'] === undefined) return false
  if (!('shopSalePointId' in value) || value['shopSalePointId'] === undefined)
    return false
  if (
    !('shopPaymentPointId' in value) ||
    value['shopPaymentPointId'] === undefined
  )
    return false
  if (!('userId' in value) || value['userId'] === undefined) return false
  if (!('createdAt' in value) || value['createdAt'] === undefined) return false
  if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false
  return true
}

export function SaleFromJSON(json: any): Sale {
  return SaleFromJSONTyped(json, false)
}

export function SaleFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Sale {
  if (json == null) {
    return json
  }
  return {
    id: json['id'],
    saleId: json['saleId'],
    countItems: json['countItems'],
    priceItemsBuy: json['priceItemsBuy'],
    priceItems: json['priceItems'],
    priceItemsDiscount: json['priceItemsDiscount'],
    priceDiscount: json['priceDiscount'],
    sumCommission: json['sumCommission'],
    sumRaise: json['sumRaise'],
    priceFinal: json['priceFinal'],
    sumGive: json['sumGive'],
    sumBack: json['sumBack'],
    dateOperation: json['dateOperation'],
    shopId: json['shopId'],
    shopSalePointId: json['shopSalePointId'],
    shopPaymentPointId: json['shopPaymentPointId'],
    userId: json['userId'],
    createdAt: json['createdAt'],
    updatedAt: json['updatedAt'],
  }
}

export function SaleToJSON(json: any): Sale {
  return SaleToJSONTyped(json, false)
}

export function SaleToJSONTyped(
  value?: Sale | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value
  }

  return {
    id: value['id'],
    saleId: value['saleId'],
    countItems: value['countItems'],
    priceItemsBuy: value['priceItemsBuy'],
    priceItems: value['priceItems'],
    priceItemsDiscount: value['priceItemsDiscount'],
    priceDiscount: value['priceDiscount'],
    sumCommission: value['sumCommission'],
    sumRaise: value['sumRaise'],
    priceFinal: value['priceFinal'],
    sumGive: value['sumGive'],
    sumBack: value['sumBack'],
    dateOperation: value['dateOperation'],
    shopId: value['shopId'],
    shopSalePointId: value['shopSalePointId'],
    shopPaymentPointId: value['shopPaymentPointId'],
    userId: value['userId'],
    createdAt: value['createdAt'],
    updatedAt: value['updatedAt'],
  }
}
